module.exports = __webpack_public_path__ + "img/cutout_double-exposure.84aa03e.svg";